<template>
  <modal
    :show="show"
    :on-close="closeModal"
    :show-close-button="false"
    size="medium"
    :data-testid="TEST_IDS.MODAL_ROOT"
  >
    <button
      type="button"
      class="subcategories-modal-close-button"
      :data-testid="TEST_IDS.MODAL_CLOSE_BUTTON"
      @click="closeModal"
    >
      <fluent-icon icon="dismiss" size="18" />
    </button>
    <modal-header :header-title="translations.modalTitle" />
    <div class="subcategories-modal-body">
      <public-search-input
        :data-testid="TEST_IDS.MODAL_SEARCH_INPUT"
        :value="searchTerm"
        :search-placeholder="translations.searchPlaceholder"
        @input="onSearchInput"
      />
      <div class="subcategories-modal-results">
        <div
          v-if="isFiltering"
          :data-testid="TEST_IDS.MODAL_LOADING_STATE"
          class="subcategories-modal-loading-state"
        >
          <span class="subcategories-modal-spinner" />
        </div>
        <p
          v-else-if="!hasResults"
          :data-testid="TEST_IDS.MODAL_EMPTY_STATE"
          class="subcategories-modal-empty-state"
        >
          {{ translations.noResults }}
        </p>
        <ul v-else class="subcategories-modal-list">
          <li v-for="subcategory in paginatedSubcategories" :key="subcategory">
            <a
              :data-testid="rowTestId(subcategory)"
              :href="subcategoryHref(subcategory)"
              :class="{ 'is-active': isRowActive(subcategory) }"
            >
              {{ subcategory }}
            </a>
          </li>
        </ul>
      </div>
      <div
        v-if="!isFiltering && hasResults && totalPages > 1"
        class="subcategories-modal-pagination"
      >
        <table-footer-pagination
          :data-testid="TEST_IDS.MODAL_PAGINATION"
          :current-page="currentPage"
          :total-pages="totalPages"
          :total-count="filteredSubcategories.length"
          @page-change="onPageChange"
        />
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from 'dashboard/components/Modal.vue';
import ModalHeader from 'dashboard/components/ModalHeader.vue';
import TableFooterPagination from 'dashboard/components/widgets/TableFooterPagination.vue';
import PublicSearchInput from '../PublicSearchInput.vue';
import subcategoriesModalMixin from './mixins/subcategoriesModalMixin';

export default {
  name: 'SubcategoriesModal',
  components: { Modal, ModalHeader, TableFooterPagination, PublicSearchInput },
  mixins: [subcategoriesModalMixin],
};
</script>

<style src="./styles/SubcategoriesModal.scss" lang="scss" scoped></style>
